(function () {
  /* ===== Menu do telemóvel ===== */
  var burger = document.querySelector('.burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('menu');
      burger.setAttribute('aria-expanded', open);
    });
    document.querySelectorAll('.nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('menu');
        burger.setAttribute('aria-expanded', false);
      });
    });
  }

  /* ===== Página de produto: escolha de variante ===== */
  var root = document.querySelector('[data-product-section]');
  if (!root) return;

  var fieldsets = [].slice.call(root.querySelectorAll('[data-option]'));
  if (!fieldsets.length) return; // produto sem opções: nada a atualizar

  var data = JSON.parse(root.querySelector('[data-product-json]').textContent);
  var idInput = root.querySelector('[data-variant-id]');
  var buy = root.querySelector('[data-buy]');
  var price = root.querySelector('[data-price]');

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-PT', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function selected() {
    return fieldsets.map(function (f) {
      var c = f.querySelector('input:checked');
      return c ? c.value : null;
    });
  }

  function matches(variant, sel) {
    return variant.options.every(function (o, i) { return o === sel[i]; });
  }

  function find(sel) {
    return data.variants.find(function (v) { return matches(v, sel); });
  }

  function update() {
    var sel = selected();
    var v = find(sel);

    /* desativa valores sem nenhuma variante disponível (dadas as outras escolhas) */
    fieldsets.forEach(function (f, i) {
      f.querySelectorAll('input').forEach(function (inp) {
        var test = sel.slice();
        test[i] = inp.value;
        var ok = data.variants.some(function (vv) { return vv.available && matches(vv, test); });
        inp.disabled = !ok && !inp.checked;
      });
      var label = f.querySelector('[data-selected-label]');
      if (label) label.textContent = sel[i];
    });

    if (!v) {
      buy.disabled = true;
      buy.textContent = buy.dataset.unavailable;
      return;
    }
    idInput.value = v.id;
    price.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
    buy.disabled = !v.available;
    buy.textContent = v.available ? buy.dataset.add : buy.dataset.sold;
    if (window.history && history.replaceState) {
      history.replaceState(null, '', '?variant=' + v.id);
    }
  }

  root.addEventListener('change', function (e) {
    if (!e.target.matches('[data-option] input')) return;
    var sel = selected();
    var v = find(sel);
    /* se a combinação não existe ou está esgotada, muda as outras opções para uma disponível */
    if (!v || !v.available) {
      var i = fieldsets.indexOf(e.target.closest('[data-option]'));
      var alt = data.variants.find(function (vv) { return vv.available && vv.options[i] === e.target.value; });
      if (alt) {
        fieldsets.forEach(function (f, k) {
          f.querySelectorAll('input').forEach(function (inp) { inp.checked = (inp.value === alt.options[k]); });
        });
      }
    }
    update();
  });

  update();
})();